import {
  ADMIN,
  ADMINS,
  CONTRACT_ADDRESS,
  EXPLORER_ADDRESS,
  HELPER,
  shortAddress,
} from '../../constants/constants';
import { PaymentProps } from '../../interfaces/props/PaymentProps';
import { useWallet } from '../wallet/WalletProvider';
import './PaymentComponent.css';

const Payment: React.FC<PaymentProps> = ({
  totalPayout,
  tokenBalance,
  paySalaries,
  getTransactions,
  usdBalance,
  usdHelperBalance,
}) => {
  const { isReady } = useWallet();

  const fmt = (v: string | number) => {
    const num = Math.floor(Number(v));
    return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  return (
    <div className="payment">
      <div className="payment__left">
        <div className="payment__admin-section">
          <div className="payment__admin-title">Главный админ:</div>
          <div className="payment__admin">{ADMIN}</div>
        </div>
        <div className="payment__admins">
          <div className="payment__admin-title">Админы:</div>
          {ADMINS.map((admin, index) => (
            <span key={index}>{admin}</span>
          ))}
        </div>
      </div>
      <div className="payment__right">
        <div className="payment__info">
          Сумма выплаты: <strong>{totalPayout}</strong> EMIVN
        </div>
        <div className="payment__info">
          Баланс токенов на{' '}
          <a
            href={`${EXPLORER_ADDRESS}${CONTRACT_ADDRESS}`}
            target="_blank"
            rel="noreferrer"
          >
            контракте
          </a>
          : <strong>{fmt(tokenBalance)}</strong> EMIVN
        </div>
        <div className="payment__info">
          Баланс админа{' '}
          <a
            href={`${EXPLORER_ADDRESS}${ADMIN}`}
            target="_blank"
            rel="noreferrer"
          >
            {shortAddress(ADMIN)}
          </a>
          : <strong>{usdBalance}</strong> USD
        </div>
        <div className="payment__info">
          Баланс <span style={{ color: 'red' }}>helper</span>'а{' '}
          <a
            href={`${EXPLORER_ADDRESS}${HELPER}`}
            target="_blank"
            rel="noreferrer"
          >
            {shortAddress(HELPER)}
          </a>
          : <strong>{usdHelperBalance}</strong> USD
        </div>
        <div className="payment__buttons">
          <button
            className="payment__button--green"
            onClick={paySalaries}
            disabled={!isReady}
            title={isReady ? '' : 'Подключите кошелёк в сети BSC'}
          >
            Выплатить всем
          </button>
          <button className="payment__button--brown" onClick={getTransactions}>
            Все выплаты
          </button>
        </div>
      </div>
    </div>
  );
};

export default Payment;
